import { isNull } from 'lodash'
import { useCallback, useEffect, useRef } from 'react'

import useProductBoardItemsFilter from './useProductBoardItemsFilter'

import { usePaginatedProductBoardItemsQuery } from '~generated/hooks'
import { PaginationInput } from '~generated/types'

type UsePaginatedRoadmapItems = {
  filterStateKey: string
  launchesIds?: string[] | null
  parentItemId?: string | null | undefined
}

export const defaultPaginatedRoadmapItemsPagination: PaginationInput = {
  page: 1,
  limit: 20,
}

function usePaginatedRoadmapItems({ filterStateKey, launchesIds, parentItemId }: UsePaginatedRoadmapItems) {
  const pageRef = useRef(1)

  const [filter, applyFilter] = useProductBoardItemsFilter({
    key: filterStateKey,
    defaultState: () => {
      return {}
    },
  })

  const { data, loading, fetchMore } = usePaginatedProductBoardItemsQuery({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    variables: {
      filter: {
        ...filter,
        launchIds: launchesIds || isNull(launchesIds) ? launchesIds : filter.launchIds,
        parentItemId,
      },
      pagination: defaultPaginatedRoadmapItemsPagination,
    },
  })

  useEffect(() => {
    pageRef.current = 1
  }, [filter, launchesIds])

  const loadMore = useCallback(() => {
    if (!loading && pageRef.current < data?.paginatedProductBoardItems?.totalPages) {
      pageRef.current += 1

      fetchMore({
        variables: {
          pagination: {
            ...defaultPaginatedRoadmapItemsPagination,
            page: pageRef.current,
          },
        },
      })
    }
  }, [loading, data?.paginatedProductBoardItems?.totalPages, fetchMore])

  return {
    loading,
    data,
    loadMore,
    filter,
    applyFilter,
  }
}

export default usePaginatedRoadmapItems
